import React from "react";
//import Swiper from 'react-id-swiper';
//import 'swiper/css/swiper.css';
//import WOW from "wow.js";

// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footers/Footer.js";
import HeroBanner from "components/HeroBanner/HeroBanner.js";
import Features from "components/Features/Features.js";
import Advantage from "components/Advantage/Advantage.js";
import Launcher from "components/Launcher/Launcher.js";
//import Team from "components/Team/Team.js";
import Quality from "components/Quality/Quality.js";
import Clients from "components/Clients/Clients.js";
import Help from "components/Help/Help.js";

// Cookies Consent
import CookieConsent, { Cookies } from "react-cookie-consent";
// import PayByFaceModel from "components/PayByFaceModel/index";

//import $ from "jquery";

class Index extends React.Component {
  state = {
    open: false,
  };
  // componentDidMount() {
  //   setTimeout(() => {
  //     this.setState({
  //       open: !this.state.open,
  //     });
  //   }, 2000);
  //   // document.documentElement.scrollTop = 0;
  //   // document.scrollingElement.scrollTop = 0;
  //   // this.refs.main.scrollTop = 0;
  //   // const wow = new WOW();
  //   // wow.init();
  //   if (localStorage.getItem("location") === "Thankyou") {
  //     // window.history.pushState("/", null, null);
  //     // window.addEventListener("popstate", this._onBackButtonEvent, false);
  //   }

  //   // window.addEventListener("popstate", function () {
  //   //   alert("Back button was pressed.");
  //   // });
  //   // window.addEventListener("popstate", this.onBackButtonEvent);
  //   // window.onpopstate = this._onBackButtonEvent;
  //   // window.onpopstate = (e) => {
  //   //   alert("hello");
  //   // };

  //   // window.addEventListener(
  //   //   "popstate",
  //   //   function (event) {
  //   //     window.history.go(1);
  //   //   },
  //   //   false
  //   // );
  // }
  componentDidUpdate() {
    // console.log("hellllllo");
    // window.onpopstate = (e) => {
    //   alert("hello");
    // };
    // if (localStorage.getItem("location") === "Thankyou") {
    //   window.addEventListener("popstate", this._onBackButtonEvent, false);
    // }
  }
  componentWillUnmount() {
    // window.removeEventListener("popstate", this._onBackButtonEvent);
  }
  _onBackButtonEvent = (e) => {
    // e.preventDefault();
    // console.log("e", e);
    // alert("hello");
    // if (window.confirm("Do you want to go back ?")) {
    // your logic
    // window.history.push("/");
    // }
    // if (!finishStatus) {
    //     if (window.confirm("Do you want to go back ?")) {
    //         setfinishStatus(true)
    //         // your logic
    //         props.history.push("/");
    //     } else {
    //         window.history.pushState(null, null, window.location.pathname);
    //         setfinishStatus(false)
    //     }
    // }
  };
  freshChatClick = () => {
    // if (window.fcWidget.isOpen() !== true) {
    //     window.fcWidget.open();
    // }
  };
  // toggleModel = () => {
  //   this.setState({
  //     open: !this.state.open,
  //   });
  // };

  render() {
    return (
      <>
        <CookieConsent>
          This website uses cookies to enhance the user experience.
        </CookieConsent>
        <Navbar />
        <main ref="main" className="dv-main">
          <HeroBanner />
          <Features />
          <Advantage />
          <Launcher />
          {/* <Team /> */}
          <Quality />
          <Clients />
          <Help />
        </main>
        <Footer />
        {/* <PayByFaceModel open={this.state.open} toggleModel={this.toggleModel} /> */}
      </>
    );
  }
}

export default Index;
